import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from "../../containers/captcha";
import logo from "./img/klubb-logo.webp";

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({ open: false, message: "" });

    const encodedUsername = encodeURIComponent(username);

    api
      .userPassLogin(
        {
          username: encodedUsername,
          password,
        },
        parameters
      )
      .then((response) => {
        setOnLogin(false);
        window.location = `${parameters.redirect_uri}?${queryString.stringify(response)}`;
      })
      .catch((requestError) => {
        const translated = translate(requestError.errorCode);
        let message = translate("RequestLoginErrorMessage");

        if (translated) {
          message = translated;
        } else if (requestError.details) {
          message = requestError.details;
        }
        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef} className="yekkoclub-card">
        <div className="yekkoclub-left">
          <div className="yekkoclub-logo">
            <img src={logo} alt="Yekko Club" />
          </div>
          <h1>Iniciar Sesión</h1>
          <p className="yekkoclub-subtitle">Bienvenido de vuelta! Por favor ingresa tus credenciales.</p>

          <Form onSubmit={onSubmit} className="yekkoclub-form">
            <label htmlFor="yekkoclub-username">Correo electronico</label>
            <input
              id="yekkoclub-username"
              type="text"
              disabled={onLogin}
              required={true}
              autoCorrect="off"
              autoCapitalize="none"
              placeholder="tu@ejemplo.com"
              onChange={(e) => setUsername(e.target.value)}
            />

            <label htmlFor="yekkoclub-password">Contrasena</label>
            <input
              id="yekkoclub-password"
              type="password"
              disabled={onLogin}
              required={true}
              autoCorrect="off"
              autoCapitalize="none"
              placeholder="Ingresa tu contrasena"
              onChange={(e) => setPassword(e.target.value)}
            />

            {!onLogin ? (
              <button type="submit">
                Iniciar sesión
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}

            <div className="yekkoclub-captcha">
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </div>

            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>

            <div className="yekkoclub-footer-text">
              <p>
                No tienes una cuenta?{" "}
                <a href="https://junior.klubb.com.co/register" target="_blank" rel="noreferrer">
                  Registrarse
                </a>
              </p>
              <p>
                <a href="https://junior.klubb.com.co/forgot-password" target="_blank" rel="noreferrer">
                  Olvidaste tu contrasena?
                </a>
              </p>
            </div>
          </Form>
        </div>

        <div className="yekkoclub-right" />
      </div>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true });
